import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import { SelectInput } from '../Inputs/Inputs.jsx'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

const Run = ({ device }) => {
  const applicationSettings = device.application_settings || { settings: {} }
  const applicationSettingsNew = device.application_settings_new || { settings: {} }

  const [original, setOriginal] = useState(applicationSettings.settings.run)
  const [run, setRun] = useState(
    applicationSettingsNew.settings.run
      ? applicationSettingsNew.settings.run
      : applicationSettings.settings.run
  )

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: {
        address: device.address,
        status: 'new',
        settings: {
          run,
        },
      },
    })
  }, [run, device.address])

  useEffect(() => {
    appDispatch()
  }, [run])

  const handleChange = useCallback((field, value, callback) => {
    setRun(Number(value))
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const unit = ''

  const updateSelect = [
    {
      value: 0,
      name: 'No',
    },
    {
      value: 1,
      name: 'Yes',
    },
  ]

  return (
    <div>
      <section>
        <h3>
          Current Setting
        </h3>
        <ul>
          <li>
            <span>Machine Run</span>
            <span>
              {original ? 'Yes' : 'No'}
              {unit}
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>
          New Setting
        </h3>
        <ul>
          <li>
            <span>Machine Run</span>
            <span>
              <SelectInput
                value={run}
                options={updateSelect}
                childChange={childChange}
                field='run'
              />
              {unit}
            </span>
          </li>
        </ul>
      </section>
    </div>
  )
}

Run.propTypes = {
  device: PropTypes.object.isRequired,
}

export default Run
